import React, { useEffect, useState } from "react";
import "./Login.css";
import { API, clearSession, saveSession, tokenExpired, startExpiryTimer } from "../util/auth";

const LoginPage: React.FC = () => {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!tokenExpired()) {
      window.location.href = "/";
    } else {
      clearSession();
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    const form = new URLSearchParams();
    form.append("username", userId);
    form.append("password", password);

    try {
      const r = await fetch(`${API}/token`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: form.toString(),
      });
      if (!r.ok) throw new Error();

      const { access_token: token } = await r.json();
      saveSession(token);
      startExpiryTimer();
      window.location.href = "/";
    } catch {
      setError("Incorrect ID or Password");
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card login-container">
        <span className="auth-badge">NCS/EMG AI Workspace</span>
        <h1 className="auth-title">Sign in</h1>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && <div className="auth-error">{error}</div>}

          <div className="field-group">
            <label htmlFor="userId">User ID</label>
            <input
              id="userId"
              className="app-input"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              required
            />
          </div>

          <div className="field-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              className="app-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="app-button primary">
            Enter Workspace
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
